enum ChatSource {
    Internal = 1,
    MessageBird = 2,
}

export default ChatSource;
